import styled from "styled-components";
import { Card } from "../../card/card";
import { css } from "styled-components";

export const List = styled.ul`
  overflow-y: auto;
  scrollbar-width: thin;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizes.spacing.sm};
  /* max-height: 250px; */
  /* overflow-y: auto; */
`;

export const Wrapper = styled.div`
  transition: 0.5s;
  padding-top: 1rem;
  max-width: 1000px;
  margin: 0 auto;
  .bi-chevron-icon {
    transition: 0.5s;
    transform: rotate(-180deg);
  }
  /* position: fixed;
  bottom: 90px;
  width: 100%;

  ${({ expanded }) => !expanded && css`
    position: fixed;
    bottom: -180px;
    width: 100%;
    .bi-chevron-icon {
      transform: initial;
    }
  `} */
`
export const ContainerCardToolbar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1211;
`
export const ContainerCard = styled(Card)`
  background: ${({ theme }) => theme.mode === 'dark' ? "#333" : '#ebebeb'};
  padding-bottom: 3rem;
  position: relative;
`;

export const ChaptersLabel = styled.div`
  display: flex;
  gap: 5px;
  color: ${({ theme }) => theme.colors.text};
  font-weight: bold;
  align-items: center;
  margin-bottom: 1rem;
  span {
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ theme }) => theme.palette.gray[900]};
    color: #fff;
    height: 20px;
    width: 20px;
    font-size: 12px;
  }
`